// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1BulkForecastsImportSchema = z.object({
  create: z.optional(z.array(z.object({
    user_id: z.number().int(),
    project_id: z.number().int(),
    hours: z.optional(z.number().int().min(0)),
    minutes: z.optional(z.number().int().min(0).max(59)),
    day: z.coerce.string(),
    note: z.coerce.string().nullish(),
  })).describe("Array of tasks to create. Each item accepts all standard task fields from Tasks.")),
  update: z.optional(z.array(z.object({
    id: z.number().int().describe("Task ID to update"),
  })).describe("Array of tasks to update. Must include id field. All other fields from Forecasts::UpdatePayloadSchema are optional.")),
  delete: z.optional(z.array(z.number().int()).describe("Array of task IDs to delete")),
});
